export const browseData = [
	{
		label: "Chlorophytes",
		children: [
			{
				id: "Chlamydomonas_reinhardtii",
				label: "Chlamydomonas reinhardtii",
			},
			{
				id: "Coccomyxa_subellipsoidea",
				label: "Coccomyxa subellipsoidea",
			},
			{
				id: "Micromonas_pusilla",
				label: "Micromonas pusilla",
			},
			{
				id: "Micromonas_commoda",
				label: "Micromonas commoda",
			},
			{
				id: "Ostreococcus_lucimarinus",
				label: "Ostreococcus lucimarinus",
			},
			{
				id: "Volvox_carteri",
				label: "Volvox carteri",
			},
			{
				id: "Dunaliella_salina",
				label: "Dunaliella salina",
			},
		],
	},
	{
		label: "Embryophytes",
		children: [
			{
				label: "Tracheophytes",
				children: [
					{
						label: "Spermatophytes",
						children: [
							{
								label: "Magnoliophyta",
								children: [
									{
										id: "Amborella_trichopoda",
										label: "Amborella trichopoda",
									},
									{
										label: "Eudicotyledons",
										children: [
											{
												label: "Brassicaceae",
												children: [
													{
														id: "Arabidopsis_thaliana",
														label: "Arabidopsis thaliana",
													},
													{
														id: "Capsella_grandiflora",
														label: "Capsella grandiflora",
													},
													{
														id: "Eutrema_salsugineum",
														label: "Eutrema salsugineum",
													},
													{
														id: "Capsella_rubella",
														label: "Capsella rubella",
													},
													{
														id: "Arabidopsis_lyrata",
														label: "Arabidopsis lyrata",
													},
													{
														id: "Brassica_napus",
														label: "Brassica napus",
													},
													{
														id: "Brassica_rapa",
														label: "Brassica rapa",
													},
												],
											},
											{
												label: "Solanaceae",
												children: [
													{
														id: "Nicotiana_tabacum",
														label: "Nicotiana tabacum",
													},
													{
														id: "Nicotiana_benthamiana",
														label: "Nicotiana benthamiana",
													},
													{
														id: "Solanum_lycopersicum",
														label: "Solanum lycopersicum",
													},
													{
														id: "Solanum_tuberosum",
														label: "Solanum tuberosum",
													},
													{
														id: "Capsicum_annuum",
														label: "Capsicum annuum",
													},
													{
														id: "Solanum_melongena",
														label: "Solanum melongena",
													},
													{
														id: "Solanum_pimpinellifolium",
														label: "Solanum pimpinellifolium",
													},
												],
											},
											{
												label: "Caricaceae",
												children: [
													{
														id: "Carica_papaya",
														label: "Carica papaya",
													},
												],
											},
											{
												label: "Rutaceae",
												children: [
													{
														id: "Citrus_clementina",
														label: "Citrus clementina",
													},
													{
														id: "Citrus_sinensis",
														label: "Citrus sinensis",
													},
													{
														id: "Citrus_maxima",
														label: "Citrus maxima",
													},
												],
											},
											{
												label: "Cucurbitaceae",
												children: [
													{
														id: "Cucumis_sativus",
														label: "Cucumis sativus",
													},
													{
														id: "Mimulus_guttatus",
														label: "Mimulus guttatus",
													},
												],
											},
											{
												label: "Rosaceae",
												children: [
													{
														id: "Fragaria_vesca",
														label: "Fragaria vesca",
													},
													{
														id: "Prunus_persica",
														label: "Prunus persica",
													},
													{
														id: "Malus_domestica",
														label: "Malus domestica",
													},
												],
											},
											{
												label: "Malvaceae",
												children: [
													{
														id: "Gossypium_raimondii",
														label: "Gossypium raimondii",
													},
													{
														id: "Gossypium_barbadense",
														label: "Gossypium barbadense",
													},
													{
														id: "Theobroma_cacao",
														label: "Theobroma cacao",
													},
												],
											},
											{
												label: "Linaceae",
												children: [
													{
														id: "Linum_usitatissimum",
														label: "Linum usitatissimum",
													},
												],
											},
											{
												label: "Fabaceae",
												children: [
													{
														id: "Glycine_max",
														label: "Glycine max",
													},
													{
														id: "Medicago_truncatula",
														label: "Medicago truncatula",
													},
													{
														id: "Phaseolus_vulgaris",
														label: "Phaseolus vulgaris",
													},
													{
														id: "Cicer_arietinum",
														label: "Cicer arietinum",
													},
													{
														id: "Lotus_japonicus",
														label: "Lotus japonicus",
													},
													{
														id: "Pisum_sativum",
														label: "Pisum sativum",
													},
													{
														id: "Vigna_radiata",
														label: "Vigna radiata",
													},
													{
														id: "Lupinus_angustifolius",
														label: "Lupinus angustifolius",
													},
													{
														id: "Arachis_ipaensis",
														label: "Arachis ipaensis",
													},
													{
														id: "Trifolium_pratense",
														label: "Trifolium pratense",
													},
												],
											},
											{
												label: "Salicaceae",
												children: [
													{
														id: "Populus_trichocarpa",
														label: "Populus trichocarpa",
													},
													{
														id: "Populus_tremula",
														label: "Populus tremula",
													},
												],
											},
											{
												label: "Euphorbiaceae",
												children: [
													{
														id: "Manihot_esculenta",
														label: "Manihot esculenta",
													},
													{
														id: "Ricinus_communis",
														label: "Ricinus communis",
													},
													{
														id: "Jatropha_curcas",
														label: "Jatropha curcas",
													},
												],
											},
											{
												label: "Vitaceae",
												children: [
													{
														id: "Vitis_vinifera",
														label: "Vitis vinifera",
													},
												],
											},
											{
												label: "Bombacaceae",
												children: [
													{
														id: "Durio_zibethinus",
														label: "Durio zibethinus",
													},
												],
											},
										],
									},
									{
										label: "Liliopsida",
										children: [
											{
												label: "Poaceae",
												children: [
													{
														id: "Oryza_sativa",
														label: "Oryza sativa",
													},
													{
														id: "Oryza_brachyantha",
														label: "Oryza brachyantha",
													},
													{
														id: "Zea_mays",
														label: "Zea mays",
													},
													{
														id: "Triticum_aestivum",
														label: "Triticum aestivum",
													},
													{
														id: "Brachypodium_distachyon",
														label: "Brachypodium distachyon",
													},
													{
														id: "Setaria_italica",
														label: "Setaria italica",
													},
													{
														id: "Sorghum_bicolor",
														label: "Sorghum bicolor",
													},
													{
														id: "Hordeum_vulgare",
														label: "Hordeum vulgare",
													},
													{
														id: "Panicum_hallii",
														label: "Panicum hallii",
													},
													{
														id: "Setaria_viridis",
														label: "Setaria viridis",
													},
												],
											},
											{
												label: "Bromeliaceae",
												children: [
													{
														id: "Ananas_comosus",
														label: "Ananas comosus",
													},
												],
											},
											{
												label: "Arecaceae",
												children: [
													{
														id: "Elaeis_guineensis",
														label: "Elaeis guineensis",
													},
													{
														id: "Phoenix_dactylifera",
														label: "Phoenix dactylifera",
													},
													{
														id: "Spirodela_polyrhiza",
														label: "Spirodela polyrhiza",
													},
												],
											},
											{
												label: "Zosteraceae",
												children: [
													{
														id: "Zostera_marina",
														label: "Zostera marina",
													},
												],
											},
											{
												label: "Musaceae",
												children: [
													{
														id: "Musa_acuminata",
														label: "Musa acuminata",
													},
												],
											},
										],
									},
									{
										label: "Dicotyledons",
										children: [
											{
												label: "Myrtaceae",
												children: [
													{
														id: "Eucalyptus_grandis",
														label: "Eucalyptus grandis",
													},
												],
											},
											{
												label: "Apiaceae",
												children: [
													{
														id: "Daucus_carota",
														label: "Daucus carota",
													},
												],
											},
											{
												label: "Scrophulariaceae",
												children: [
													{
														id: "Erythranthe_guttata",
														label: "Erythranthe guttata",
													},
												],
											},
											{
												label: "Asteraceae",
												children: [
													{
														id: "Lactuca_sativa",
														label: "Lactuca sativa",
													},
												],
											},
											{
												label: "Oleaceae",
												children: [
													{
														id: "Olea_europaea",
														label: "Olea europaea",
													},
												],
											},
											{
												label: "Araliaceae",
												children: [
													{
														id: "Panax_ginseng",
														label: "Panax ginseng",
													},
												],
											},
											{
												label: "Actinidiaceae",
												children: [
													{
														id: "Actinidia_chinensis",
														label: "Actinidia chinensis",
													},
												],
											},
											{
												label: "Ranunculaceae",
												children: [
													{
														id: "Aquilegia_coerulea",
														label: "Aquilegia coerulea",
													},
												],
											},
											{
												label: "Rubioideae",
												children: [
													{
														id: "Coffea_arabica",
														label: "Coffea arabica",
													},
												],
											},
											{
												label: "Lamiaceae",
												children: [
													{
														id: "Salvia_miltiorrhiza",
														label: "Salvia miltiorrhiza",
													},
												],
											},
										],
									},
								],
							},
							{
								label: "Embryophyta",
								children: [
									{
										id: "Physcomitrella_patens",
										label: "Physcomitrella patens",
									},
									{
										id: "Selaginella_moellendorffii",
										label: "Selaginella moellendorffii",
									},
								],
							},
							{
								label: "Gymnospermae",
								children: [
									{
										label: "Coniferopsida",
										children: [
											{
												label: "Taxodiaceae",
												children: [
													{
														id: "Picea_abies",
														label: "Picea abies",
													}
												],
											}
										],
									},
								],
							},
						],
					},
				],
			},
			{
				label: "Polyporaceae",
				children: [
					{
						id: "Ganoderma_lucidum",
						label: "Ganoderma lucidum",
					},
				],
			},
		],
	},
]
